export const userList = (state) => state.userList;

export const getPaginatedUsersList = (state) => state.paginatedUsersList;

export const userDDL = (state) => state.userDDL;

export const loadingUsers = (state) => state.loadingUsers;

export const getUsersRoleList = (state) => state.selectedRoleUsers;

export const getCurrentUsers = (state) => state.currentUsersForRole || [];

export const getUsersforEdit = (state) => state.currentUsersForRole;

export const getProcessDetailsAndRoles = (state) => state.processDetailsAndRoles;
